import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { updateComment } from '../services/budgetCommentsService'
import { budgetCommentsKeys } from './budgetCommentsQueryKeys'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { filtersSelector } from '../../../redux/context/filters/selectors'
import type { BudgetComment } from '../types'

export const useUpdateComment = () => {
  const queryClient = useQueryClient()
  const companyId = useSelector(contextCompanyIdSelector)
  const { budgetingScenario } = useSelector(filtersSelector)

  return useMutation({
    mutationFn: async ({
      commentId,
      comment
    }: {
      commentId: number
      comment: Partial<Omit<BudgetComment, 'id' | 'companyId' | 'userId' | 'createdAt' | 'updatedAt'>>
    }) => {
      if (!companyId) {
        throw new Error('Company ID is required')
      }

      return updateComment({
        companyId,
        commentId,
        comment,
        budgetingScenarioId: budgetingScenario?.id
      })
    },

    onSuccess: () => {
      // Invalidate comments queries to refetch data
      queryClient.invalidateQueries({
        queryKey: budgetCommentsKeys.comments()
      })
    },

    onError: error => {
      console.error('Error updating comment:', error)
    }
  })
}
